import { useEffect, useState } from "react";
import { useLanguage } from "@/context/LanguageContext";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    if (!localStorage.getItem("dtm-consent")) setShow(true);
  }, []);

  const choose = (value) => {
    localStorage.setItem("dtm-consent", value);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-label={t("cookie.title")}
      className="fixed bottom-6 left-4 z-[75] max-w-sm border border-white/15 bg-[#121212]/95 p-5 backdrop-blur-xl sm:left-6"
    >
      <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">{t("cookie.title")}</div>
      <p className="mt-2 text-xs leading-relaxed text-white/65">{t("cookie.text")}</p>
      <div className="mt-4 flex gap-3">
        <button
          data-testid="cookie-accept"
          onClick={() => choose("accepted")}
          className="bg-ivory px-4 py-2 font-mono text-[10px] uppercase tracking-[0.25em] text-black transition-colors hover:bg-gold"
        >
          {t("cookie.accept")}
        </button>
        <button
          data-testid="cookie-decline"
          onClick={() => choose("declined")}
          className="border border-white/20 px-4 py-2 font-mono text-[10px] uppercase tracking-[0.25em] text-white/70 transition-colors hover:border-gold hover:text-gold"
        >
          {t("cookie.decline")}
        </button>
      </div>
    </div>
  );
};
